import { connect } from 'react-redux';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';

import { State } from 'client/store';
import { getHomepage, isLoading } from 'client/store/homepage/selectors';
import { getEvents, isLoading as isEventsLoading } from 'client/store/event/selectors';
import { fetchHomepage } from 'client/store/homepage/thunks';
import { fetchEvents } from 'client/store/event/thunks';
import HomeContent, { DispatchProps, StateProps } from './home-content';

const urlPropsQueryConfig = {
    q: { type: UrlQueryParamTypes.string },
};

const mapStateToProps = (state: State): StateProps => ({
    data: getHomepage(state),
    isLoading: isLoading(state),
    isEventsLoading: isEventsLoading(state),
    events: getEvents(state),
});

const mapDispatchToProps = {
    fetchHomepage,
    fetchEvents,
};

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(addUrlProps({ urlPropsQueryConfig })(HomeContent));
